/**
 * SearchBar — UI stub deshabilitada.
 *
 * El endpoint de búsqueda global llega en una versión futura (`v2` según
 * el prototipo). Mostramos el input visualmente con el shortcut `⌘K` para
 * preservar la UX promise, pero está disabled y no captura interacción.
 */

import { Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function SearchBar() {
  const { t } = useTranslation('shell')

  return (
    <div className="flex-1 max-w-md">
      <div
        className="relative"
        title={t('search.disabled_title')}
      >
        <Search
          className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-subtle pointer-events-none"
          aria-hidden="true"
        />
        <input
          type="search"
          disabled
          placeholder={t('search.placeholder')}
          aria-label={t('search.placeholder')}
          className="w-full bg-surface-muted border border-line rounded-md pl-9 pr-12 py-1.5 text-sm text-ink-muted placeholder:text-ink-subtle focus:outline-none disabled:cursor-not-allowed"
        />
        <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-mono text-ink-subtle border border-line rounded px-1.5 py-0.5 pointer-events-none">
          {t('search.shortcut_hint')}
        </span>
      </div>
    </div>
  )
}
